export const getErrorMessage = (error) => {
    var _a, _b;
    if (!error) {
        return '';
    }
    const serializedError = error;
    if (serializedError.name && serializedError.message) {
        if ((_a = serializedError.data) === null || _a === void 0 ? void 0 : _a.errorMessage) {
            return serializedError.data.errorMessage;
        }
        if ((_b = serializedError.data) === null || _b === void 0 ? void 0 : _b.error_description) {
            return serializedError.data.error_description;
        }
        return serializedError.message;
    }
    return error.message || String(error);
};
